import { useSelector } from "react-redux";
import AttendancePrincipal from "./principal/AttendancePrincipal.js";
import AttendanceTeacher from "./teacher/AttendanceTeacher.js";
import AttendanceStudent from "./student/AttendanceStudent.js";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import AttendanceParent from "./parent/AttendanceParent.js";

function Attendance() {
  const state = useSelector((state) => state);
  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <AttendancePrincipal />;
    }
    if (state.auth.user.is_teacher) {
      return <AttendanceTeacher />;
    }
    if (state.auth.user.is_student) {
      return <AttendanceStudent />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <AttendanceParent />;
      }
      return <Loader />;
    }
    return <PermissionDenied />;
  }
}

export default Attendance;
